module.exports = __webpack_public_path__ + "assets/img/gansujinkong.a88cc84c.png";